import { OpenInNewTabIcon } from "@gadgetinc/themes/src/icons/OpenInNewTabIcon";
import { useStyletron } from "baseui";
import type { LinkProps } from "baseui/link";
import { StyledLink } from "baseui/link";
import { merge } from "lodash";
import type { ComponentProps } from "react";
import React from "react";
import { useWorkspace } from "../workspace/WorkspaceContext";

export function useSlugifiedExternalHref(href: undefined): undefined;
export function useSlugifiedExternalHref(href: string): string;
export function useSlugifiedExternalHref(href: string | undefined): string | undefined;
export function useSlugifiedExternalHref(href: string | undefined) {
  const workspace = useWorkspace();
  // support being used outside the edit context
  if (!workspace) return href;

  const settings = workspace.settings.getOrSuspend();

  if (!href) return href;

  if (href.startsWith(window.GadgetEditConfig.docsRootURL + "/guides")) {
    const url = new URL(href);
    url.searchParams.set("slug", settings.applicationSlug);
    href = url.toString();
  }
  return href;
}

export const ExternalLink = (props: LinkProps & ComponentProps<typeof StyledLink> & { href: string }) => {
  const [css, $theme] = useStyletron();
  const href = useSlugifiedExternalHref(props.href);

  const $style = merge(
    {
      textUnderlineOffset: "0px",
      whiteSpace: "nowrap",
      wordBreak: "keep-all",
    },
    props.$style
  );

  return (
    <span>
      <StyledLink {...props} href={href} $style={$style} target="_blank">
        {props.children}
        <OpenInNewTabIcon className={css({ marginLeft: $theme.sizing.scale200 })} />
      </StyledLink>
    </span>
  );
};
